// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"f1b091f2","261":"71310958"}[chunkId] + ".chunk.css";
};